export default {
  "meta-title": "TARISLAND",
  "meta-description": "Tarisland is a classic MMORPG on PC and mobile devices, featuring raids, diverse classes, crossplay and a vast world for exploration. Embark on your epic adventure together.",
  "meta-keywords": "tarisland,taris,comme wow,mmo,mmorpg,multiplateforme,mmomobile,mmoPC",
  "meta-name": "Tarisland Official Website",
  "meta-image": "${HOST_NAME}/assets/images/share.jpg",
  "meta-og-site_name": "Tarisland Official Website",
  "meta-og-title": "Tarisland Official Website",
  "meta-og-description": "You will experience a classic cross-platform MMORPG and team up with your closet friends to enjoy the hardcore raids.",
  "meta-og-url": "${HOST_NAME}/${LANG}/home.html",
  "meta-og-url2": "${HOST_NAME}/${LANG}/index.html",
  "meta-og-image": "${HOST_NAME}/assets/images/share.jpg",
  "meta-twitter-site": "${HOST_NAME}",
  "meta-twitter-title": "Tarisland Official Website",
  "meta-twitter-description": "You will experience a classic cross-platform MMORPG and team up with your closet friends to enjoy the hardcore raids.",
  "meta-twitter-url": "${HOST_NAME}/${LANG}/home.html",
  "meta-twitter-url2": "${HOST_NAME}/${LANG}/index.html",
  "meta-twitter-image": "${HOST_NAME}/assets/images/share.jpg",


  "email_illegal": "Incorrect Email address. Please check and resubmit it.",
  "horizon_tip": "For a better experience, please rotate your device.",





  'downloadPc': "Please download on PC",

  "area": "Gebiet",
  "select-area": "Bitte wähle ein Gebiet.",
  "server": "Server",
  "select-server": "Bitte wähle einen Server.",
  "character-name": "Charaktername",
  "select-character": "Bitte wähle einen Charakter.",
  "please-select": "Please select",
  "not-found-role": "Character information not found",
  'loading': 'loading....',
  'pls_input_info': 'Please enter your login information.',
  'FlowHasNotBegin': 'The event has not started yet',
  'FlowHasEnd': 'The event has ended',

  // 复制到剪贴板内容 需要拼接
  "copy_clipboard-text1": "Werde jetzt mein Tarisland-Partner!\nKlicke/Tippe auf:",
  "copy_clipboard-text2": " (exklusiver Link)\nWenn der Link fehlschlägt, gib den Einladungscode ein:",
  "friends-completed": "Freunde abgeschlossen",
  "no-friends-completed": "Keine Freunde abgeschlossen",
  "pop_invitedlist_s": "ABGESCHLOSSEN",
  "pop_invitedlist_f": "NICHT ABGESCHLOSSEN",
  "gift3": "S1-Wachstumspaket",
  "gift5": "Geist des Frostwolfs (dauerhaft)",
  "gift6": "Geist des Frostwolfs (1 Tag)",
  "gift1": "Geschenkkarte: 100$",
  "gift2": "Geschenkkarte: 50$",
  "gift4": "Geist des Feuerelement-Tigers (dauerhaft)",

  "invite_link_upper_limit": "Dieser Einladungslink oder Code hat die maximale Anzahl an Verwendungen bereits erreicht.",
  "invite_link_disabled": "Ungültiger Einladungslink oder abgelaufener Code. Bitte wende dich an den Absender der Einladung.",
  "enter_your_invitation_code": "Gib deinen Einladungscode ein",
  "act_not_start": "Das Event hat noch nicht begonnen.",
  "act_finished": "Das Event ist beendet.",
  "download_pc": "Bitte auf den PC herunterladen",
  "email_error": "Ungültige E-Mail. Bitte überprüfen.",
  "loadding": "Laden …",
  "check_my_raffle_history": "Meinen Verlosungsverlauf ansehen",
  "no_raffle_history": "Kein Verlosungsverlauf",
  "system-error": "Systemfehler",
  "cant-invite-self": "Du kannst dich nicht selbst einladen",
}